import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["toggleContent", "toggleContent1"];
  static values = { ticketTransfer: String };

  connect() {
    console.log(this.ticketTransferValue);
    const noRestriction = document.getElementById("no_restriction");
    if (["restrict_all", "restrict_per_ticket"].includes(noRestriction.dataset.value)) {
      document.getElementById("set_restrict").checked = true;
      this.showSlide();
    }
  }

  toggleContent(action, target) {
    if (action === "slideDown") {
      $(target).slideDown(200);
    } else if (action === "slideUp") {
      $(target).slideUp(200);
    }
  }

  showSlide() {
    this.toggleContent("slideDown", this.toggleContentTarget);
    const noRestriction = document.getElementById("no_restriction");
    noRestriction.checked = false;
    if (noRestriction.dataset.value === "restrict_per_ticket") {
      document.getElementById("restrict_per_ticket").checked = true;
      this.showSlide1();
    } else {
      document.getElementById("restrict_all").checked = true;
      this.hideSlide2();
    }
  }

  showSlide1() {
    this.toggleContent("slideDown", this.toggleContent1Target);
    document.getElementById("no_restriction").dataset.value = "restrict_per_ticket";
  }

  hideSlide2() {
    this.toggleContent("slideUp", this.toggleContent1Target);
    document.getElementById("no_restriction").dataset.value = "restrict_all";
  }

  hideSlide3() {
    this.toggleContent("slideUp", this.toggleContentTarget);
    document.getElementById("set_restrict").checked = false;
  }
}
